import Vue from 'vue';
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './theme/index.css';
import '@/assets/css/icomoon/icomoon.css';
import App from './App.vue';
import router from './router';
import store from './store/store';
import url from '@/config';
import {http, catchAppError} from '@/util';
import toast from './toast';

Vue.prototype.$url = url;
Vue.prototype.$http = http;
Vue.prototype.$catch = catchAppError;
Vue.prototype.$toast = toast;
Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue();

Vue.config.productionTip = false;

Vue.use(ElementUI);

new Vue({
  router,
  store,
  data: {
    eventHub: new Vue()
  },
  render: h => h(App)
}).$mount('#app');
